export const formatNumber = (value: number | null | undefined): string => {
  if (value == null || Number.isNaN(value)) {
    return '—';
  }
  if (value >= 1_000_000_000) {
    return `${(value / 1_000_000_000).toFixed(1)}B`;
  }
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`;
  }
  if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`;
  }
  return value.toLocaleString();
};

export const formatDateTime = (value: string | Date | null | undefined): string => {
  if (!value) {
    return '—';
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString();
};

export const formatRelativeTime = (value: string | Date | null | undefined): string => {
  if (!value) {
    return '—';
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  const diffMs = Date.now() - date.getTime();
  const abs = Math.abs(diffMs);
  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;

  const formatter = (valueMs: number, unit: string) => {
    const qty = Math.round(valueMs);
    return diffMs >= 0 ? `${qty}${unit} ago` : `in ${qty}${unit}`;
  };

  if (abs < minute) {
    return diffMs >= 0 ? 'just now' : 'in <1m';
  }
  if (abs < hour) {
    return formatter(abs / minute, 'm');
  }
  if (abs < day) {
    return formatter(abs / hour, 'h');
  }
  return formatter(abs / day, 'd');
};

export const formatDuration = (
  startedAt: string | Date | null | undefined,
  finishedAt: string | Date | null | undefined = new Date()
): string => {
  if (!startedAt) {
    return '—';
  }
  const start = startedAt instanceof Date ? startedAt : new Date(startedAt);
  const end = finishedAt instanceof Date ? finishedAt : finishedAt ? new Date(finishedAt) : new Date();
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return '—';
  }
  const diffMs = Math.max(0, end.getTime() - start.getTime());
  const hours = Math.floor(diffMs / (60 * 60 * 1000));
  const minutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((diffMs % (60 * 1000)) / 1000);

  const parts: string[] = [];
  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }
  if (parts.length === 0) {
    parts.push(`${seconds}s`);
  }
  return parts.join(' ');
};
